// MP-custom: Alpine helpers (variant picker copy, partial-rerender Alpine init)
// MP-custom: cart ghost line sync (pant qty ↔ ghost; cart:updateItemQuantity / cart:addToCart bridge)
// MP-custom: MP condensed countdown — Alpine `mpCondensedCountdownBar` + `mpCondensedMobileStrip` (see sections/mp--countdown-condensed.liquid, mp-announcement-with-timer.liquid)

function mpCountdownRollingScheduledEndMs(anchorMs, intervalMs, now) {
  if (now < anchorMs) {
    return anchorMs;
  }
  const delta = now - anchorMs;
  const k = Math.floor(delta / intervalMs);
  return anchorMs + (k + 1) * intervalMs;
}

// MP-custom: re-mount flip countdown-timer so theme.js restarts each 17h cycle
function mpFlipCountdownRollingResync(el) {
  const hours = Math.max(1, Number(el.getAttribute('data-mp-rolling-hours')) || 17);
  const endMs = mpCountdownRollingScheduledEndMs(0, hours * 3600000, Date.now());
  const currentMs = Date.parse(el.getAttribute('expires-at') || '');
  if (!Number.isNaN(currentMs) && currentMs > Date.now()) return;
  const next = el.cloneNode(true);
  next.classList.remove('is-ready');
  next.setAttribute('expires-at', new Date(endMs).toISOString());
  el.replaceWith(next);
}

function mpFlipCountdownDaysIsZero(daysFlip) {
  if (!daysFlip?.shadowRoot?.children?.length) return true;
  return [...daysFlip.shadowRoot.children].every((digit) => {
    const value = digit.getAttribute('number') ?? digit.textContent;
    return value === '0';
  });
}

function mpFlipCountdownUpdateDaysVisibility(timer) {
  const daysFlip = timer.querySelector('countdown-timer-flip[type="days"]');
  timer.classList.toggle(
    'countdown-condensed__timer--hms',
    mpFlipCountdownDaysIsZero(daysFlip)
  );
}

function mpFlipCountdownRevealWhenReady(timer) {
  if (timer.classList.contains('is-ready')) return;
  const flip =
    timer.querySelector('countdown-timer-flip[type="hours"]') ??
    timer.querySelector('countdown-timer-flip');
  if (!flip?.shadowRoot?.children?.length) return;
  if ([...flip.shadowRoot.children].some((digit) => digit.hasAttribute('number'))) {
    timer.classList.add('is-ready');
    if (timer._mpRevealFallback) {
      clearTimeout(timer._mpRevealFallback);
      timer._mpRevealFallback = null;
    }
  }
}

function mpFlipCountdownInitCondensedTimer(timer) {
  mpFlipCountdownUpdateDaysVisibility(timer);
  mpFlipCountdownRevealWhenReady(timer);
  if (!timer.classList.contains('is-ready') && !timer._mpRevealFallback) {
    timer._mpRevealFallback = window.setTimeout(() => {
      timer.classList.add('is-ready');
    }, 2000);
  }
}

function mpInitFlipCountdownRollingResync() {
  const tick = () => {
    document.querySelectorAll('countdown-timer[data-mp-rolling-hours]').forEach(mpFlipCountdownRollingResync);
    document.querySelectorAll('countdown-timer.countdown-condensed__timer').forEach(mpFlipCountdownInitCondensedTimer);
  };
  tick();
  setInterval(tick, 1000);
}

function mpFlipCountdownWatchCondensedTimers() {
  customElements.whenDefined('countdown-timer').then(() => {
    document.querySelectorAll('countdown-timer.countdown-condensed__timer').forEach((el) => {
      mpFlipCountdownInitCondensedTimer(el);
      requestAnimationFrame(() => mpFlipCountdownInitCondensedTimer(el));
    });
  });
}

// MP-custom: group PDP gallery by color (swap from variant-picker product:rerender fragment)
function mpEscapeFormId(formId) {
  return typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(formId) : formId;
}

function mpGetGalleryCarousel(gallery) {
  return gallery.querySelector('.product-gallery__carousel');
}

function mpScrollGalleryToFeaturedMedia(gallery, variant) {
  if (!variant?.featured_media) return;
  const carousel = mpGetGalleryCarousel(gallery);
  const mediaId = String(variant.featured_media.id);
  const cell = gallery.querySelector(`[data-media-id="${mediaId}"]`);
  if (!cell) return;
  if (carousel?.isScrollable) {
    const index = carousel.cells.indexOf(cell);
    if (index >= 0) carousel.select(index, { instant: true });
  } else {
    cell.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }
}

function mpSelectGalleryInitialSlide(gallery) {
  const carousel = mpGetGalleryCarousel(gallery);
  const initial = gallery.querySelector('.product-gallery__media.is-initial');
  if (!initial) return;
  if (carousel?.isScrollable) {
    const index = carousel.cells.indexOf(initial);
    if (index >= 0) carousel.select(index, { instant: true });
  } else {
    initial.scrollIntoView({ block: 'start', behavior: 'auto' });
  }
}

function mpGalleryColorChanged(variant, previousVariant, colorOptionPosition) {
  const pos = parseInt(colorOptionPosition, 10) - 1;
  if (pos < 0 || !variant?.options || !previousVariant?.options) return false;
  return variant.options[pos] !== previousVariant.options[pos];
}

function mpGetVariantFromFragment(fragment, formId) {
  const picker = mpGetVariantPickerFromFragment(fragment, formId);
  const script = picker?.querySelector('script[data-variant]');
  if (!script?.textContent) return null;
  try {
    return JSON.parse(script.textContent);
  } catch {
    return null;
  }
}

function mpDeepQuerySelector(root, selector) {
  let element = root.querySelector(selector);
  if (element) return element;
  for (const template of root.querySelectorAll('template')) {
    element = mpDeepQuerySelector(template.content, selector);
    if (element) return element;
  }
  return null;
}

function mpGetGalleryMarkupFromFragment(fragment, formId) {
  const selector = `product-gallery[form="${mpEscapeFormId(formId)}"]`;
  return mpDeepQuerySelector(fragment, selector);
}

function mpGetVariantPickerFromFragment(fragment, formId) {
  return mpDeepQuerySelector(
    fragment,
    `variant-picker[form-id="${mpEscapeFormId(formId)}"]`
  );
}

function mpReplaceGalleryFromFragment(gallery, fragment, variant) {
  const markup = mpGetGalleryMarkupFromFragment(
    fragment,
    gallery.getAttribute('form')
  );
  if (!markup) return false;

  const imported = document.importNode(markup, true);
  gallery.replaceWith(imported);

  const pos = parseInt(imported.dataset.colorOptionPosition, 10) - 1;
  if (pos >= 0 && variant?.options?.[pos] != null) {
    imported.dataset.color = variant.options[pos];
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      mpSelectGalleryInitialSlide(imported);
      mpScheduleProductGalleryThumbAxisScroll();
    });
  });
  return true;
}

async function mpRefreshGallerySectionId(gallery, variant) {
  const sectionId = gallery.dataset.sectionId;
  if (!sectionId || !variant?.id) return;

  const formId = gallery.getAttribute('form');
  const form = formId && document.forms[formId];
  if (!form) return;

  form._mpGalleryAbort?.abort();
  form._mpGalleryAbort = new AbortController();
  const { signal } = form._mpGalleryAbort;
  form._mpGalleryLastVariantId = variant.id;

  try {
    const url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set('variant', variant.id);
    url.searchParams.set('section_id', sectionId);
    const res = await fetch(url.toString(), { signal });
    if (!res.ok || form._mpGalleryLastVariantId !== variant.id) return;

    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const newGallery = doc.querySelector(
      `product-gallery[form="${mpEscapeFormId(formId)}"]`
    );
    if (!newGallery) return;

    const live = document.querySelector(
      `product-gallery[data-group="true"][form="${formId}"]`
    );
    if (!live) return;

    live.replaceWith(newGallery);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        mpSelectGalleryInitialSlide(newGallery);
        mpScheduleProductGalleryThumbAxisScroll();
      });
    });
  } catch (err) {
    if (err.name === 'AbortError') return;
  }
}

function mpInitProductGalleryColorGroup() {
  document.querySelectorAll('product-gallery[data-group="true"]').forEach((gallery) => {
    const formId = gallery.getAttribute('form');
    const form = formId && document.forms[formId];
    if (!form || form._mpGalleryColorBound) return;
    form._mpGalleryColorBound = true;

    form.addEventListener(
      'product:rerender',
      (event) => {
        if (!event.detail?.productChange && event.detail?.htmlFragment) {
          form._mpLastRerenderFragment = event.detail.htmlFragment;
        }
      },
      true
    );

    form.addEventListener(
      'variant:change',
      (event) => {
        const activeGallery = document.querySelector(
          `product-gallery[data-group="true"][form="${formId}"]`
        );
        if (!activeGallery) return;

        const { variant, previousVariant } = event.detail || {};
        if (!variant) return;

        if (
          mpGalleryColorChanged(
            variant,
            previousVariant,
            activeGallery.dataset.colorOptionPosition
          )
        ) {
          const fragment = form._mpLastRerenderFragment;
          const replaced =
            fragment &&
            mpReplaceGalleryFromFragment(activeGallery, fragment, variant);
          if (!replaced) {
            mpRefreshGallerySectionId(activeGallery, variant);
          }
          event.stopImmediatePropagation();
          return;
        }

        mpScrollGalleryToFeaturedMedia(activeGallery, variant);
        event.stopImmediatePropagation();
      },
      true
    );
  });
}

// MP-custom: mobile sticky ATC — stay visible over footer
function mpInitProductStickyBarMobileFooter() {
  const mq = window.matchMedia('(max-width: 699px)');

  document.querySelectorAll('product-sticky-bar').forEach((bar) => {
    if (bar._mpStickyMobileBound) return;
    const form = document.forms[bar.getAttribute('form')];
    if (!form) return;
    bar._mpStickyMobileBound = true;

    let formPast = false;
    const apply = () => {
      if (mq.matches) bar.classList.toggle('is-visible', formPast);
    };

    const formIo = new IntersectionObserver(([entry]) => {
      formPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      apply();
    });
    formIo.observe(form);

    const classMo = new MutationObserver(() => {
      if (mq.matches && formPast && !bar.classList.contains('is-visible')) {
        bar.classList.add('is-visible');
      }
    });
    classMo.observe(bar, { attributes: true, attributeFilter: ['class'] });

    mq.addEventListener('change', apply);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    mpInitFlipCountdownRollingResync();
    mpFlipCountdownWatchCondensedTimers();
    mpInitProductGalleryColorGroup();
    mpInitProductStickyBarMobileFooter();
    mpScheduleProductGalleryThumbAxisScroll();
  });
} else {
  mpInitFlipCountdownRollingResync();
  mpFlipCountdownWatchCondensedTimers();
  mpInitProductGalleryColorGroup();
  mpInitProductStickyBarMobileFooter();
  mpScheduleProductGalleryThumbAxisScroll();
}

document.addEventListener('shopify:section:load', mpInitProductGalleryColorGroup);
document.addEventListener('shopify:section:load', mpInitProductStickyBarMobileFooter);
document.addEventListener('shopify:section:load', mpScheduleProductGalleryThumbAxisScroll);

// MP-custom: mobile + desktop timer cells share data-mp-condensed-* on the same section id
function mpCountdownDomResolver(detail) {
  const id = detail.instanceId ?? detail.condensedInstanceId;
  if (id != null && id !== '') {
    const sid = String(id);
    const esc = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(sid) : sid;
    return {
      getTimeEls: () =>
        document.querySelectorAll(`[data-mp-condensed-time="${esc}"]`),
      getHosts: () =>
        document.querySelectorAll(`[data-mp-condensed-host="${esc}"]`),
    };
  }
  const { selector, hostSelector } = detail;
  if (!selector || !hostSelector) return null;
  return {
    getTimeEls: () => {
      const el = document.querySelector(selector);
      return el ? [el] : [];
    },
    getHosts: () => {
      const el = document.querySelector(hostSelector);
      return el ? [el] : [];
    },
  };
}

function mpCountdownHideHosts(resolver) {
  resolver.getHosts().forEach((host) => host.classList.add('u-visually-hidden'));
}

function mpCountdownShowZero(resolver, prefix) {
  const prefixStr = prefix != null ? String(prefix) : '';
  const text = `${prefixStr}0:00:00`;
  resolver.getTimeEls().forEach((el) => {
    el.textContent = text;
  });
}

function mpCountdownScheduledRolling({ anchorMs, intervalMs, resolver, prefix }) {
  const els = resolver.getTimeEls();
  if (!els.length) return;
  const prefixStr = prefix != null ? String(prefix) : '';
  const tick = () => {
    const now = Date.now();
    const endMs = mpCountdownRollingScheduledEndMs(anchorMs, intervalMs, now);
    const ms = endMs - now;
    const line =
      ms <= 0
        ? `${prefixStr}0:00:00`
        : (() => {
            const s = Math.floor(ms / 1000);
            const h = Math.floor(s / 3600);
            const m = Math.floor((s % 3600) / 60);
            const sec = s % 60;
            return `${prefixStr}${h}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
          })();
    els.forEach((el) => {
      el.textContent = line;
    });
  };
  tick();
  return setInterval(tick, 500);
}

function mpCountdownFixedEnd({ date_timestamp, resolver, prefix, onComplete }) {
  const els = resolver.getTimeEls();
  if (!els.length) return;
  const prefixStr = prefix != null ? String(prefix) : '';
  let intervalId = null;
  let completeFired = false;
  const finish = () => {
    if (completeFired) return;
    completeFired = true;
    if (intervalId != null) {
      clearInterval(intervalId);
      intervalId = null;
    }
    onComplete?.();
  };
  const tick = () => {
    const ms = date_timestamp - Date.now();
    const line =
      ms <= 0
        ? `${prefixStr}0:00:00`
        : (() => {
            const s = Math.floor(ms / 1000);
            const h = Math.floor(s / 3600);
            const m = Math.floor((s % 3600) / 60);
            const sec = s % 60;
            return `${prefixStr}${h}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
          })();
    els.forEach((el) => {
      el.textContent = line;
    });
    if (ms <= 0) {
      finish();
    }
  };
  tick();
  if (completeFired) return;
  intervalId = setInterval(tick, 500);
}

function mpCountdownRefreshAnnouncementBarHeight(sectionShellId) {
  const root =
    typeof sectionShellId === 'string' && sectionShellId
      ? document.getElementById(sectionShellId)
      : null;
  if (!root?.classList.contains('shopify-section--announcement-bar')) {
    return;
  }
  document.documentElement.style.setProperty(
    '--announcement-bar-height',
    `${root.clientHeight.toFixed(2)}px`
  );
}

function mpCountdownEmitComplete(detail) {
  document.dispatchEvent(
    new CustomEvent('mp-announcement-countdown-complete', {
      bubbles: true,
      detail,
    })
  );
}

/** MP-custom: entry — same fields as Liquid passes to `mpCondensedCountdownBar({ ... })` */
function mpCountdownStart(d) {
  const {
    prefix,
    fixedEndIso,
    rolling,
    rollingHours,
    rollingAnchorIso,
    storageKey,
    sectionShellId,
    hideHostOnComplete,
    selector,
    hostSelector,
  } = d;
  const condensedId = d.instanceId ?? d.condensedInstanceId;

  const shouldHideHost = hideHostOnComplete !== false;

  if (!storageKey) return;

  const resolver = mpCountdownDomResolver(d);
  if (!resolver || !resolver.getTimeEls().length) return;

  let endMs;

  try {
    if (rolling) {
      const hours = Math.min(
        8760,
        Math.max(1, Number(rollingHours) || 24)
      );
      const spanMs = hours * 3600000;
      const anchorStr =
        typeof rollingAnchorIso === 'string' ? rollingAnchorIso.trim() : '';

      if (anchorStr) {
        const anchorMs = Date.parse(anchorStr);
        if (Number.isNaN(anchorMs)) {
          mpCountdownHideHosts(resolver);
          return;
        }
        mpCountdownScheduledRolling({
          anchorMs,
          intervalMs: spanMs,
          resolver,
          prefix,
        });
        return;
      }

      const raw = window.localStorage.getItem(storageKey);
      if (raw) {
        const parsed = Date.parse(raw);
        if (!Number.isNaN(parsed)) {
          if (parsed > Date.now()) {
            endMs = parsed;
          } else {
            try {
              window.localStorage.removeItem(storageKey);
            } catch (_) {}
            if (shouldHideHost) {
              mpCountdownHideHosts(resolver);
            }
            else {
              mpCountdownShowZero(resolver, prefix);
            }
            mpCountdownEmitComplete({
              storageKey,
              selector,
              hostSelector,
              condensedInstanceId: condensedId,
            });
            mpCountdownRefreshAnnouncementBarHeight(sectionShellId);
            return;
          }
        }
      }
      if (endMs == null) {
        endMs = Date.now() + spanMs;
        window.localStorage.setItem(storageKey, new Date(endMs).toISOString());
      }
    } else {
      const iso = typeof fixedEndIso === 'string' ? fixedEndIso.trim() : '';
      if (!iso) {
        mpCountdownHideHosts(resolver);
        return;
      }
      endMs = Date.parse(iso);
      if (Number.isNaN(endMs)) {
        mpCountdownHideHosts(resolver);
        return;
      }
    }
  } catch (e) {
    mpCountdownHideHosts(resolver);
    return;
  }

  if (endMs <= Date.now()) {
    if (rolling) {
      try {
        window.localStorage.removeItem(storageKey);
      } catch (_) {}
    }
    if (shouldHideHost) {
      mpCountdownHideHosts(resolver);
    }
    else {
      mpCountdownShowZero(resolver, prefix);
    }
    mpCountdownEmitComplete({
      storageKey,
      selector,
      hostSelector,
      condensedInstanceId: condensedId,
    });
    mpCountdownRefreshAnnouncementBarHeight(sectionShellId);
    return;
  }

  mpCountdownFixedEnd({
    date_timestamp: endMs,
    resolver,
    prefix,
    onComplete: () => {
      if (rolling) {
        try {
          window.localStorage.removeItem(storageKey);
        } catch (_) {}
      }
      if (shouldHideHost) {
        mpCountdownHideHosts(resolver);
      }
      mpCountdownEmitComplete({
        storageKey,
        selector,
        hostSelector,
        condensedInstanceId: condensedId,
      });
      mpCountdownRefreshAnnouncementBarHeight(sectionShellId);
    },
  });
}

function mpStripIntervalMs(carousel, opts) {
  const fromOpts = opts?.seconds;
  const raw =
    fromOpts != null && fromOpts !== ''
      ? Number(fromOpts)
      : parseInt(carousel.getAttribute('data-mp-autoplay-seconds'), 10);
  return Math.max(2000, (Number.isFinite(raw) ? raw : 3) * 1000);
}

/* MP-custom: duplicate first slide at end; smooth onto clone then instant jump to real first */
function mpStripEnsureLoopClone(carousel) {
  if (carousel._mpLoopCloneEl) return;
  const realCells = carousel.cells;
  if (realCells.length < 2) return;

  const first = realCells[0];
  const clone = first.cloneNode(true);
  clone.classList.add('mp-condensed-loop-clone');
  clone.classList.remove('is-initial');
  clone.setAttribute('aria-hidden', 'true');
  carousel.appendChild(clone);
  carousel._mpLoopCloneEl = clone;
  carousel._mpStripRealLength = realCells.length;

  carousel.addEventListener('carousel:settle', () => {
    if (carousel.selectedCell === carousel._mpLoopCloneEl) {
      carousel.select(0, { instant: true });
    }
  });
}

function mpStripAutoplayEnabled(carousel, opts) {
  if (opts?.autoplay === true) return true;
  if (opts?.autoplay === false) return false;
  return carousel.getAttribute('data-mp-autoplay') === 'true';
}

function mpStripAttachAutoplay(carousel, opts) {
  if (!mpStripAutoplayEnabled(carousel, opts)) return;
  if (carousel._mpStripAutoplayId != null) return;
  const realLen = carousel._mpStripRealLength;
  if (!realLen || realLen < 2) return;

  const ms = mpStripIntervalMs(carousel, opts);
  carousel._mpStripAutoplayId = window.setInterval(() => {
    const current = carousel.selectedIndex;
    if (current >= realLen) {
      carousel.select(0, { instant: true });
      return;
    }
    const next = current + 1;
    carousel.select(next, { instant: false });
  }, ms);
}

document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('.mp-condensed-mobile-strip').forEach((c) => {
    if (c._mpStripAutoplayId != null) {
      window.clearInterval(c._mpStripAutoplayId);
      c._mpStripAutoplayId = null;
    }
  });
});

// SV- MP-custom: logo size vars
let mpHeaderLogoResizeObserver = null;
let mpHeaderLogoObservedEl = null;
let mpHeaderLogoFrameId = null;

function mpHeaderLogoEl() {
  return document.querySelector(
    '.header__logo-image:not(.header__logo-image--transparent)'
  );
}

function mpSyncHeaderLogoSize() {
  const el = mpHeaderLogoEl();
  if (!el) return;

  const rect = el.getBoundingClientRect();
  const root = document.documentElement;

  root.style.setProperty('--mp-header-logo-width', `${rect.width.toFixed(2)}px`);
  root.style.setProperty(
    '--mp-header-logo-height',
    `${rect.height.toFixed(2)}px`
  );
}

function mpObserveHeaderLogo() {
  if (!window.ResizeObserver) return;

  const el = mpHeaderLogoEl();
  if (el === mpHeaderLogoObservedEl) return;

  mpHeaderLogoResizeObserver?.disconnect();
  mpHeaderLogoObservedEl = el;

  if (!el) return;

  mpHeaderLogoResizeObserver = new ResizeObserver(() => {
    mpScheduleHeaderLogoSync();
  });
  mpHeaderLogoResizeObserver.observe(el);
}

function mpScheduleHeaderLogoSync() {
  if (mpHeaderLogoFrameId != null) return;

  mpHeaderLogoFrameId = window.requestAnimationFrame(() => {
    mpHeaderLogoFrameId = null;
    mpObserveHeaderLogo();
    mpSyncHeaderLogoSize();
  });
}

function mpInitHeaderLogoSize() {
  mpObserveHeaderLogo();
  mpScheduleHeaderLogoSync();
}

// MP-custom: PDP thumb strip — vertical swipe scrolls page; clear horizontal swipe scrolls thumbs (≤699px)
function mpInitProductGalleryThumbAxisScroll(root = document) {
  const mq = window.matchMedia('(max-width: 699px)');
  const AXIS_LOCK = 12;

  root
    .querySelectorAll('product-gallery-navigation.product-gallery__thumbnail-scroller')
    .forEach((el) => {
      if (el._mpThumbAxisBound) {
        return;
      }
      el._mpThumbAxisBound = true;

      let touch = null;

      const resetTouch = () => {
        if (!touch) {
          return;
        }
        el.style.removeProperty('scroll-snap-type');
        el.style.removeProperty('touch-action');
        touch = null;
      };

      const onTouchStart = (e) => {
        if (!mq.matches || e.touches.length !== 1) {
          return;
        }
        if (el.scrollWidth <= el.clientWidth + 1) {
          return;
        }
        touch = {
          x: e.touches[0].clientX,
          y: e.touches[0].clientY,
          scrollLeft: el.scrollLeft,
          axis: null,
        };
      };

      const onTouchMove = (e) => {
        if (!touch || !mq.matches || e.touches.length !== 1) {
          return;
        }

        const dx = e.touches[0].clientX - touch.x;
        const dy = e.touches[0].clientY - touch.y;
        const absX = Math.abs(dx);
        const absY = Math.abs(dy);

        if (touch.axis === null) {
          if (absX < AXIS_LOCK && absY < AXIS_LOCK) {
            return;
          }
          // Prefer page scroll unless horizontal is clearly dominant
          touch.axis = absX > absY * 1.25 ? 'x' : 'y';
          if (touch.axis === 'x') {
            el.style.scrollSnapType = 'none';
            el.style.touchAction = 'none';
          } else {
            resetTouch();
            return;
          }
        }

        if (touch.axis === 'x') {
          e.preventDefault();
          el.scrollLeft = touch.scrollLeft - dx;
        }
      };

      el.addEventListener('touchstart', onTouchStart, { passive: true });
      el.addEventListener('touchmove', onTouchMove, { passive: false });
      el.addEventListener('touchend', resetTouch, { passive: true });
      el.addEventListener('touchcancel', resetTouch, { passive: true });
    });
}

function mpScheduleProductGalleryThumbAxisScroll() {
  mpInitProductGalleryThumbAxisScroll();
}

// MP-custom: cart upsell strip — block native img drag; div list drag-scroll on desktop
function mpInitCartUpsellDragScroll(root = document) {
  const mq = window.matchMedia('(pointer: fine)');

  root
    .querySelectorAll('.cart-drawer.mp-cart .complementary-products__product-list')
    .forEach((el) => {
      if (el._mpUpsellStripBound) {
        return;
      }
      el._mpUpsellStripBound = true;

      el.addEventListener(
        'dragstart',
        (e) => {
          if (e.target.closest('.horizontal-product-card__image')) {
            e.preventDefault();
          }
        },
        true
      );

      // MP-custom: wheel-to-horizontal scroll for cart upsell strip
      const onWheel = (e) => {
        if (
          e.shiftKey ||
          Math.abs(e.deltaX) > Math.abs(e.deltaY) ||
          el.scrollWidth <= el.clientWidth
        ) {
          return;
        }

        if (
          e.deltaMode === WheelEvent.DOM_DELTA_PIXEL &&
          Math.abs(e.deltaY) < 40
        ) {
          return;
        }

        e.preventDefault();
        el.scrollLeft += e.deltaY;
      };

      el.addEventListener('wheel', onWheel, { passive: false });

      if (el.tagName === 'SCROLL-CAROUSEL') {
        return;
      }

      const syncScrollable = () => {
        el.classList.toggle('is-scrollable', el.scrollWidth > el.clientWidth);
      };

      let drag = null;

      const onMove = (e) => {
        if (!drag) return;
        e.preventDefault();
        el.scrollLeft = drag.left - (e.clientX - drag.x);
      };

      const onUp = (e) => {
        document.removeEventListener('mousemove', onMove);
        el.style.removeProperty('scroll-snap-type');
        if (drag && e.clientX - drag.x !== 0) {
          e.preventDefault();
        }
        drag = null;
      };

      el.addEventListener('mousedown', (e) => {
        if (!mq.matches || e.button !== 0 || el.scrollWidth <= el.clientWidth) {
          return;
        }
        if (e.target.closest('input, textarea, select, label')) {
          return;
        }
        drag = { left: el.scrollLeft, x: e.clientX };
        el.style.scrollSnapType = 'none';
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp, { once: true });
      });

      syncScrollable();
      if (window.ResizeObserver) {
        new ResizeObserver(syncScrollable).observe(el);
      }
    });
}

function mpScheduleCartUpsellDragScroll() {
  mpInitCartUpsellDragScroll();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mpInitHeaderLogoSize, {
    once: true,
  });
} else {
  mpInitHeaderLogoSize();
}

window.addEventListener('load', mpScheduleHeaderLogoSync);
window.addEventListener('resize', mpScheduleHeaderLogoSync);
document.addEventListener('shopify:section:load', mpInitHeaderLogoSize);
document.addEventListener('shopify:section:load', mpScheduleCartUpsellDragScroll);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mpScheduleCartUpsellDragScroll, {
    once: true,
  });
} else {
  mpScheduleCartUpsellDragScroll();
}

document.addEventListener('cart-drawer:refreshed', mpScheduleCartUpsellDragScroll);

document.addEventListener('alpine:init', () => {
  // MP-custom: countdown settings object built in Liquid on section root
  Alpine.data('mpCondensedCountdownBar', (config) => ({
    init() {
      mpCountdownStart(config || {});
    },
  }));

  // MP-custom: `{ autoplay, seconds }` from Liquid; loop clone when 2+ slides
  Alpine.data('mpCondensedMobileStrip', (opts) => ({
    init() {
      const el = this.$el;
      const o = opts || {};
      const run = () => {
        if (el.tagName !== 'SCROLL-CAROUSEL') return;
        mpStripEnsureLoopClone(el);
        mpStripAttachAutoplay(el, o);
      };
      if (window.customElements?.get('scroll-carousel')) {
        queueMicrotask(run);
      } else {
        window.customElements.whenDefined('scroll-carousel').then(run);
      }
    },
  }));

  Alpine.data('VariantPickerOption', () => ({
    optionName: '',
    selectedValue: '',
    lengthHelper: '',
    sizeHelper: '',
    lengthByValue: {
      '28': "(for heights 5'5 to 5'8)",
      '30': "(for heights 5'9 to 5'10)",
      '32': "(for heights 5'11 to 6'1)",
      '34': "(for heights 6'2 to 6'4)",
      '36': "(for heights 6'5 to 6'8)",
    },
    sizeByValue: {
      'S': 'Small',
      'M': 'Medium',
      'L': 'Large',
      'XL': 'X-Large',
      '2X': '2X-Large',
      '3X': '3X-Large',
    },
    init() {
      this.optionName = this.$el.dataset.optionName;
      this.selectedValue = this.$el.dataset.selectedValue;

      if (this.optionName === 'Length') {
        this.lengthHelper = this.lengthByValue[this.selectedValue] ?? '';
      }
      else if (this.optionName === 'Size') {
        this.sizeHelper = this.sizeByValue[this.selectedValue] ?? '';
      }
    }
  }));

  // MP-custom: Okendo rating row → smooth scroll to `.mp--oke-reviews` (snippet `mp-okendo-rating-row`)
  Alpine.data('MpOkendoRatingRow', () => ({
    canScroll: false,
    init() {
      this.canScroll = Boolean(document.querySelector('.mp--oke-reviews'));
      if (this.canScroll) {
        this.$el.setAttribute('role', 'button');
        this.$el.setAttribute('tabindex', '0');
      }
    },
    scrollToReviews(event) {
      if (!this.canScroll) return;
      event?.preventDefault?.();
      document
        .querySelector('.mp--oke-reviews')
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
  }));

  Alpine.data('mpCartGhostSync', () => ({
    _validating: false,
    _intervalId: null,
    _signalAbort: null,
    _onValidate: null,
    _onLineItem: null,
    _onVariantAdd: null,
    _onDestroy: null,
    _validateGhostLine: null,

    init() {
      const s = window.MP_OFFER_SETTINGS;
      if (!s?.prod_ghost?.variants?.[0]) {
        return;
      }

      const root =
        typeof Shopify !== 'undefined' && Shopify?.routes?.root
          ? Shopify.routes.root
          : '/';
      const ghostVariantId = String(s.prod_ghost.variants[0].id);
      const pantType = (s.pant_type_norm || 'pants').toLowerCase();

      const getPantsCount = (cart) => {
        let n = 0;
        for (const item of cart.items || []) {
          if ((item.product_type || '').toLowerCase() === pantType) {
            n += item.quantity;
          }
        }
        return n;
      };

      this._validateGhostLine = async (optionalCart) => {
        if (this._validating) {
          return;
        }
        this._validating = true;
        try {
          const cart =
            optionalCart ||
            (await (await fetch(`${root}cart.js`)).json());
          const pantsCount = getPantsCount(cart);
          const ghostLine = (cart.items || []).find(
            (i) => String(i.variant_id) === ghostVariantId
          );
          const ghostCount = ghostLine ? ghostLine.quantity : 0;
          if (ghostCount === pantsCount) {
            return;
          }
          const res = await fetch(`${root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: { [ghostVariantId]: pantsCount } })
          });
          if (res.ok) {
            document.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true })
            );
          }
        } finally {
          this._validating = false;
        }
      };

      this._onValidate = () => {
        this._validateGhostLine();
      };
      this._onLineItem = (e) => {
        const lineItem = e.target?.closest?.('line-item');
        const lineKey = lineItem
          ?.querySelector?.('[data-line-key]')
          ?.getAttribute('data-line-key');
        const detail = e.detail || {};
        document.dispatchEvent(
          new CustomEvent('cart:updateItemQuantity', {
            bubbles: true,
            detail: {
              lineKey,
              newQuantity: detail.quantity,
              cart: detail.cart,
              baseEvent: 'line-item:change'
            }
          })
        );
        this._validateGhostLine(detail.cart);
      };
      this._onVariantAdd = (e) => {
        const detail = e.detail || {};
        document.dispatchEvent(
          new CustomEvent('cart:addToCart', {
            bubbles: true,
            detail: {
              items: detail.items,
              cart: detail.cart,
              onSuccessDo: detail.onSuccessDo,
              baseEvent: 'variant:add'
            }
          })
        );
        this._validateGhostLine(detail.cart);
      };

      this._signalAbort = new AbortController();
      const { signal } = this._signalAbort;
      document.addEventListener('ValidateProducts', this._onValidate, {
        signal
      });
      document.addEventListener('line-item:change', this._onLineItem, {
        signal
      });
      document.addEventListener('variant:add', this._onVariantAdd, {
        signal
      });
      this._intervalId = setInterval(() => this._validateGhostLine(), 2500);
      this._validateGhostLine();

      this._onDestroy = () => {
        this._signalAbort?.abort();
        this._signalAbort = null;
        if (this._intervalId) {
          clearInterval(this._intervalId);
          this._intervalId = null;
        }
      };
      this.$el.addEventListener('alpine:destroy', this._onDestroy, {
        once: true
      });
    }
  }));
});
